import { Filter, RefreshCw } from "lucide-react";

export default function AnalyticsFilters({
  filters,
  uniquePlans,
  uniqueStatuses,
  onFilterChange,
  onReset,
}) {
  return (
    <div className="mb-6 rounded-2xl border border-gray-100 bg-white p-4 shadow-lg sm:p-6">
      <div className="mb-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="rounded-lg bg-blue-50 p-2">
            <Filter className="text-blue-600" size={20} />
          </div>
          <h2 className="text-xl font-bold text-gray-900">Filters & Analytics</h2>
        </div>
        <button
          type="button"
          onClick={onReset}
          className="rounded-xl bg-gray-100 p-2 text-gray-600 hover:bg-gray-200"
          title="Reset All Filters"
        >
          <RefreshCw size={18} />
        </button>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <label className="space-y-2 text-sm font-semibold text-gray-700">
          Region Type
          <select
            value={filters.regionType}
            onChange={(event) => onFilterChange("regionType", event.target.value)}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 p-3 text-sm font-medium"
          >
            <option value="All">All Regions</option>
            <option value="National">India</option>
            <option value="International">International</option>
          </select>
        </label>
        <label className="space-y-2 text-sm font-semibold text-gray-700">
          Subscription Plan
          <select
            value={filters.plan}
            onChange={(event) => onFilterChange("plan", event.target.value)}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 p-3 text-sm font-medium"
          >
            <option value="All">All Plans</option>
            {uniquePlans.map((plan) => (
              <option key={plan} value={plan}>
                {plan}
              </option>
            ))}
          </select>
        </label>
        <label className="space-y-2 text-sm font-semibold text-gray-700">
          Account Status
          <select
            value={filters.status}
            onChange={(event) => onFilterChange("status", event.target.value)}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 p-3 text-sm font-medium"
          >
            <option value="All">All Statuses</option>
            {uniqueStatuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </label>
        <label className="space-y-2 text-sm font-semibold text-gray-700">
          Group Data By
          <select
            value={filters.groupBy}
            onChange={(event) => onFilterChange("groupBy", event.target.value)}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 p-3 text-sm font-medium"
          >
            <option value="day">Daily View</option>
            <option value="week">Weekly View</option>
            <option value="month">Monthly View</option>
            <option value="year">Yearly View</option>
          </select>
        </label>
      </div>
      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <label className="space-y-2 text-sm font-semibold text-gray-700">
          Start Date
          <input
            type="date"
            value={filters.startDate}
            onChange={(event) => onFilterChange("startDate", event.target.value)}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 p-3 text-sm font-medium"
          />
        </label>
        <label className="space-y-2 text-sm font-semibold text-gray-700">
          End Date
          <input
            type="date"
            value={filters.endDate}
            onChange={(event) => onFilterChange("endDate", event.target.value)}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 p-3 text-sm font-medium"
          />
        </label>
      </div>
    </div>
  );
}
